export default function Go_Multi_case () {
  return (
    <div>
      <h1>Go_Multi_case </h1>
      <p>Multi-case</p>
    </div>
  );
}